import RestClient from './RestClient';
import { Rate } from '../../models';

class Rates extends RestClient {
    constructor() {
        super({
            model: Rate,
            entryPoint: 'rate',
            resource:   'rate',
            resources:  'rates'
        });
    }

    copyRates(payload) {
        return this.POST('/rate/copy', payload)
            .then(async (response) => {
                const text = await response.text();
                let json = {};
                if (text) {
                    try {
                        json = JSON.parse(text);
                    } catch (e) {
                        json = {};
                    }
                }
                if (!response.ok) {
                    throw this._buildApiError(json, 'Copy failed');
                }
                return json;
            });
    }

    deleteAllRates(accountId) {
        return this.POST('/rate/delete_all', { account_id: accountId })
            .then(async (response) => {
                const text = await response.text();
                let json = {};
                if (text) {
                    try {
                        json = JSON.parse(text);
                    } catch (e) {
                        json = {};
                    }
                }
                if (!response.ok) {
                    throw this._buildApiError(json, 'Delete all rates failed');
                }
                return json;
            });
    }
}

const RatesApi = new Rates();

export default RatesApi;
